<template>
    <div class="page_wrap">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="top_banner">
                <div class="back_icon"
                     @click="back"></div>
            </div>
            <div class="rank_lists">
                <div class="list_head list_item">
                    <div class="list_td">排名</div>
                    <div class="list_td">
                        <div class="name_title">姓名</div>
                    </div>
                    <div class="list_td">上传记录</div>
                </div>
                <div :class="['list_item',{'self_line':user.user_id==user_id}]"
                     v-for="user in rankList">
                    <div class="list_td">
                        <div :class="['rank_no','no'+user.ranking]">{{ user.ranking!=1&&user.ranking!=2&&user.ranking!=3 ? user.ranking : "" }}</div>
                    </div>
                    <div class="list_td">
                        <img :class="['user_portrait','no'+user.ranking]"
                             :src="user.portrait"
                             alt="">
                        <div>{{ user.user_id==user_id ? "我" : user.real_name }}</div>
                    </div>
                    <div class="list_td">
                        <div class="day_num">{{ user.clock }}天</div>
                        <div class="clock_rate">上传率{{ user.speed }}%</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            unit_class_id: this.$route.params.unit_class_id,
            loading: true,
            user_id: JSON.parse(localStorage.getItem("info")).user_id,
            rankList: []
        }
    },
    created () {
        this.$http.post(API_URL_HD_API + "/winter2023/tea/sf_ranking/", { unit_class_id: this.unit_class_id }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.rankList = res.data;
            } else {
                layer.tips(res.message);
            }
            this.loading = false;
        })
    },
    methods: {

    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.page_wrap {
    min-height: 100vh;
    background-color: #fff;
    .top_banner {
        height: 428px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/img_icon_20.jpg");
        position: relative;
        .back_icon {
            position: absolute;
            width: 85px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 21px / $ppr 35px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_16.png");
            cursor: pointer;
            top: 0;
            left: 0;
        }
    }
    .rank_lists {
        margin-top: -28px / $ppr;
        background-color: #fff;
        border-radius: 30px / $ppr 30px / $ppr 0 0;
        padding: 4px / $ppr 60px / $ppr 10px / $ppr 48px / $ppr;
        position: relative;
        z-index: 1;
        .list_item {
            display: flex;
            align-items: center;
            margin-bottom: 34px / $ppr;
            &.list_head {
                font-size: 26px / $ppr;
                color: #a0a1ad;
                line-height: 104px / $ppr;
                margin-bottom: 0;
            }
            &.self_line {
                color: #5dc47c;
                .list_td {
                    .rank_no,
                    .clock_rate {
                        color: #5dc47c !important;
                    }
                }
            }
            .list_td {
                &:first-child {
                    width: 115px / $ppr;
                    flex-shrink: 0;
                    .rank_no {
                        width: 50px / $ppr;
                        height: 60px / $ppr;
                        background-size: 100% 100%;
                        font-size: 30px / $ppr;
                        color: #a9b2b6;
                        line-height: 60px / $ppr;
                        text-align: center;
                        font-weight: bold;
                        &.no1 {
                            background-image: url("./img/img_icon_17.png");
                        }
                        &.no2 {
                            background-image: url("./img/img_icon_18.png");
                        }
                        &.no3 {
                            background-image: url("./img/img_icon_19.png");
                        }
                    }
                }
                &:nth-of-type(2) {
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    .user_portrait {
                        width: 76px / $ppr;
                        height: 76px / $ppr;
                        border-radius: 50%;
                        margin-right: 22px / $ppr;
                        font-size: 28px / $ppr;
                        &.no1 {
                            border: 3px / $ppr solid #f4bc42;
                        }
                        &.no2 {
                            border: 3px / $ppr solid #b3c0c7;
                        }
                        &.no3 {
                            border: 3px / $ppr solid #de9e65;
                        }
                    }
                }
                &:last-child {
                    width: 160px / $ppr;
                    flex-shrink: 0;
                    text-align: right;
                    .day_num {
                        font-size: 32px / $ppr;
                        font-weight: bold;
                        line-height: 42px / $ppr;
                    }
                    .clock_rate {
                        font-size: 24px / $ppr;
                        color: #a0a1ad;
                        line-height: 34px / $ppr;
                    }
                }
                .name_title {
                    width: 80px / $ppr;
                    text-align: center;
                }
            }
        }
    }
}
</style>